import { createSlice, current } from "@reduxjs/toolkit";
import getBlobDuration from "get-blob-duration";

export const RepondSlice = createSlice({
  name: "respond",
  initialState: {
    qcast: {},
    recordedVideo: "",
    recordedVideoData: null,
    editedVideo: null,
    thumbnail: null,
    title: "",
    tag: [],
    answerIndex: [],
  },
  reducers: {
    currentQcast: (state, action) => {
      const { payload } = action;
      state.qcast = payload;
    },

    saveVideo: (state, action) => {
      const { payload } = action;
      state.recordedVideo = payload;
    },

    saveVideoData: (state, action) => {
      const { payload } = action;
      state.recordedVideoData = payload;
    },

    addTranscript: (state, action) => {
      const { payload } = action;
      const currentFiles = current(state.recordedVideoData);
      state.recordedVideoData = { ...currentFiles, transcript: payload };
    },
    saveTrim: (state, { payload }) => {
      const prev = current(state.recordedVideoData);

      state.recordedVideo = payload.file;
      state.recordedVideoData = payload;
    },
    trimVideo: (state, { payload }) => {
      const prev = current(state.recordedVideoData);

      const newVideoObject = {
        ...prev,
        file: payload,
        duration: getBlobDuration(payload),
      };

      state.editedVideo = newVideoObject;
    },

    addThumbnail: (state, action) => {
      const { payload } = action;
      state.thumbnail = payload;
    },
    setTitle: (state, action) => {
      const { payload } = action;
      state.title = payload;
    },

    setTag: (state, action) => {
      const { payload } = action;

      if (payload.type === "add") {
        state.tag[payload.pos] = payload.value;
      } else if (payload.type === "del") {
        let tmpt = state.tag.filter((t, idx) => idx !== payload.pos);
        state.tag = tmpt;
      }
    },

    setAnswerIndex: (state, action) => {
      const { payload } = action;

      return { ...state, answerIndex: [...state.answerIndex, payload] };
    },

    reset: (state, action) => {
      return {
        qcast: {},
        recordedVideo: "",
        recordedVideoData: null,
        thumbnail: null,
        title: "",
        tag: [],
        answerIndex: [],
      };
    },
  },
});

export default RepondSlice.reducer;
